<button class="btn btn-success btn-block" [disabled]="isLocked" (click)="callETicket()" #button>
    <i class="fas fa-bell"></i>
    <span class="element-text">{{ 'console.call' | translate }}</span>
</button>
